import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

const DISMISS_KEY = "sos-pwa-install-dismissed-until";
const DISMISS_DAYS = 7;

function isStandalone() {
  return window.matchMedia && window.matchMedia("(display-mode: standalone)").matches
    || window.navigator.standalone === true;
}

export default function PWAInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    const dismissedUntil = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
    if (dismissedUntil && Date.now() < dismissedUntil) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", () => {
      setVisible(false); setDeferred(null);
    });
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch (e) { /* ignore */ }
    setDeferred(null); setVisible(false);
  };
  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000));
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div data-testid="pwa-install-prompt"
         className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-40 bg-white border border-slate-200 shadow-xl rounded-lg p-4 flex items-start gap-3">
      <div className="w-11 h-11 rounded-md bg-green-600 flex items-center justify-center shrink-0">
        <DownloadSimple size={22} weight="bold" className="text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-slate-900 text-sm">Install SOS as an app</div>
        <div className="text-xs text-slate-500 mt-0.5">Add to your home screen for one-tap timesheet & approval access.</div>
        <div className="mt-3 flex gap-2">
          <button data-testid="pwa-install-btn" onClick={install}
                  className="h-9 px-3 rounded bg-green-600 hover:bg-green-700 text-white text-sm font-semibold">Install</button>
          <button data-testid="pwa-dismiss-btn" onClick={dismiss}
                  className="h-9 px-3 rounded border border-slate-300 text-sm font-semibold text-slate-700 hover:bg-slate-50">Not now</button>
        </div>
      </div>
      <button aria-label="Close" onClick={dismiss} className="text-slate-400 hover:text-slate-700">
        <X size={18} />
      </button>
    </div>
  );
}
